import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { projects, projectCount } from "../data/portfolio";
import { useReel } from "./Showreel";
import { Magnetic } from "./motion";

const EMAIL = "poonamgarvbaid@gmail.com";
const LINKEDIN = "https://www.linkedin.com/in/poonam-baid";
const AVAIL = "Available for freelance — Nov 2026";

// "Get the app" pill — hidden unless the browser offers install (beforeinstallprompt) or it is iOS Safari.
function GetAppPill({ fg }) {
  const [prompt, setPrompt] = useState(null);
  const [show, setShow] = useState(false);
  const [iosSheet, setIosSheet] = useState(false);
  useEffect(() => {
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    const ua = window.navigator.userAgent || "";
    const isIOS = /iphone|ipad|ipod/i.test(ua) && !window.MSStream;
    const isSafari = /safari/i.test(ua) && !/crios|fxios|edgios/i.test(ua);
    if (isIOS && isSafari && !isStandalone) setShow(true);
    const onBip = (e) => { e.preventDefault(); setPrompt(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onBip);
    const onInstalled = () => setShow(false);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", onBip); window.removeEventListener("appinstalled", onInstalled); };
  }, []);
  if (!show) return null;
  const click = async () => {
    if (prompt) { prompt.prompt(); try { await prompt.userChoice; } catch (e) {} setPrompt(null); setShow(false); }
    else setIosSheet(true);
  };
  return (
    <>
      <button onClick={click} className="mono" style={{ color: fg, border: `1px solid ${fg}`, borderRadius: 999, padding: "7px 13px" }} data-testid="get-app-pill">⤓ Get the app</button>
      {iosSheet && (
        <div onClick={() => setIosSheet(false)} data-testid="ios-install-sheet" style={{ position: "fixed", inset: 0, zIndex: 300, background: "rgba(0,0,0,.5)", display: "flex", alignItems: "flex-end" }}>
          <div onClick={(e) => e.stopPropagation()} style={{ width: "100%", background: "#fff", color: "#0D0D12", borderRadius: "16px 16px 0 0", padding: "22px 20px 30px", textAlign: "center" }}>
            <p className="h2" style={{ fontSize: 20 }}>Add vdesigns.eps to your Home Screen</p>
            <p className="mono mt-3" style={{ color: "var(--grey)" }}>Tap the Share icon <b>⬆</b> in Safari, then choose <b>“Add to Home Screen”</b>.</p>
            <button onClick={() => setIosSheet(false)} className="mono mt-4" style={{ background: "var(--lime)", borderRadius: 999, padding: "9px 18px", border: "1px solid var(--ink)" }}>Got it</button>
          </div>
        </div>
      )}
    </>
  );
}


export function pageMeta(pathname) {
  if (pathname === "/") return { file: "index.eps", theme: "paper" };
  if (pathname.startsWith("/work/")) return { file: pathname.split("/")[2] + ".pdf", theme: "paper" };
  if (pathname.startsWith("/work")) return { file: "work.eps", theme: "paper" };
  if (pathname.startsWith("/about")) return { file: "about.eps", theme: "paper" };
  if (pathname.startsWith("/playground")) return { file: "playground.eps", theme: "ink" };
  if (pathname.startsWith("/contact")) return { file: "contact.eps", theme: "blue" };
  return { file: "404.eps", theme: "paper" };
}

export function Header() {
  const location = useLocation();
  const { theme } = pageMeta(location.pathname);
  const { openReel } = useReel();
  const [scrolled, setScrolled] = useState(false);
  const [menu, setMenu] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => { setMenu(false); }, [location.pathname]);

  const dark = theme === "ink" || theme === "blue";
  const fg = dark ? "#fff" : "var(--ink)";
  const accent = dark ? "var(--lime)" : "var(--blue)";
  const bg = scrolled
    ? (theme === "ink" ? "rgba(13,13,18,.72)" : theme === "blue" ? "rgba(30,34,255,.72)" : "rgba(242,240,234,.72)")
    : "transparent";

  const navItems = [
    { to: "/", label: "Index" },
    { to: "/work", label: "Work", sup: projectCount },
    { to: "/playground", label: "Playground" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <>
      <header
        className="fixed top-0 left-0 right-0 z-[120]"
        style={{ height: 52, background: bg, backdropFilter: scrolled ? "blur(14px)" : "none", transition: "background .3s ease", color: fg }}
        data-testid="site-header"
      >
        <div className="page-x h-full flex items-center justify-between gap-4">
          <div className="flex items-baseline gap-5">
            <Link to="/" className="display-cond" style={{ fontSize: 20, color: fg }} data-testid="logo">
              vdesigns<span style={{ color: accent }}>.eps</span>
            </Link>
            <span className="mono hidden lg:inline" style={{ opacity: .55 }}>~/POONAM-BAID/{pageMeta(location.pathname).file.toUpperCase()}</span>
          </div>

          <nav className="hidden md:flex items-center gap-6">
            {navItems.map((n) => (
              <NavLink key={n.to} to={n.to} className="mono" style={({ isActive }) => ({
                color: fg, opacity: isActive ? 1 : 0.68,
                borderBottom: isActive ? `1px solid ${accent}` : "1px solid transparent", paddingBottom: 2,
              })} data-testid={`nav-${n.label.toLowerCase()}`}>
                {n.label}{n.sup != null && <sup style={{ fontSize: 8 }}>{n.sup}</sup>}
              </NavLink>
            ))}
            <GetAppPill fg={fg} />
            <a href="/cv/Poonam-Baid-CV-2026.pdf" download className="mono" style={{ color: fg, border: `1px solid ${fg}`, borderRadius: 999, padding: "7px 13px" }} data-testid="download-cv">↓ CV</a>
            <Magnetic>
              <button onClick={openReel} className="mono" style={{ background: "var(--lime)", color: "#000", borderRadius: 999, padding: "9px 15px", border: "1px solid var(--ink)" }} data-testid="showreel-pill">
                ▶ Showreel '26
              </button>
            </Magnetic>
          </nav>

          <button className="md:hidden mono" onClick={() => setMenu(true)} style={{ color: fg, border: `1px solid ${fg}`, borderRadius: 999, width: 40, height: 40 }} data-testid="menu-open" aria-label="Open menu">≡</button>
        </div>
      </header>

      {/* mobile menu */}
      <div className="fixed inset-0 z-[130] flex flex-col md:hidden" data-testid="mobile-menu"
        style={{ background: "var(--ink)", color: "#fff", transform: menu ? "translateY(0)" : "translateY(-100%)", transition: "transform .5s cubic-bezier(.22,1,.36,1)", height: "100dvh" }}>
        <div className="page-x h-16 flex items-center justify-between">
          <span className="display-cond" style={{ fontSize: 22 }}>vdesigns<span style={{ color: "var(--lime)" }}>.eps</span></span>
          <button className="mono" style={{ color: "var(--lime)" }} onClick={() => setMenu(false)} data-testid="menu-close">CLOSE ✕</button>
        </div>
        <div className="page-x flex-1 flex flex-col justify-center gap-2">
          {navItems.map((n, i) => (
            <Link key={n.to} to={n.to} className="display" style={{ fontSize: "clamp(32px,11vw,48px)", color: "#fff", transitionDelay: `${i * 40}ms` }}>{n.label}</Link>
          ))}
          <button onClick={() => { setMenu(false); openReel(); }} className="btn btn--lime mt-6 self-start">▶ Showreel '26</button>
          <a href="/cv/Poonam-Baid-CV-2026.pdf" download className="btn btn--outline mt-2 self-start" style={{ color: "#fff", borderColor: "#fff" }}>↓ Download CV</a>
        </div>
      </div>
    </>
  );
}

export function StatusBar() {
  const location = useLocation();
  const { file } = pageMeta(location.pathname);
  const m = location.pathname.match(/^\/work\/([^/]+)$/);
  let prevNext = null;
  if (m) {
    const i = projects.findIndex((p) => p.slug === m[1]);
    if (i !== -1) {
      prevNext = {
        prev: projects[(i - 1 + projects.length) % projects.length].slug,
        next: projects[(i + 1) % projects.length].slug,
      };
    }
  }
  return (
    <div className="statusbar page-x flex items-center justify-between" style={{ height: 40 }} data-testid="status-bar">
      <span>vdesigns.eps · <span className="lime">{file}</span> · {String(projectCount).padStart(2, "0")} files</span>
      {prevNext ? (
        <span className="hidden sm:flex gap-4">
          <Link to={`/work/${prevNext.prev}`} className="ul" style={{ color: "#fff" }}>← Prev</Link>
          <Link to={`/work/${prevNext.next}`} className="ul" style={{ color: "#fff" }}>Next →</Link>
        </span>
      ) : (
        <span className="hidden sm:inline"><span className="lime">●</span> {AVAIL}</span>
      )}
    </div>
  );
}

export function Footer() {
  const [time, setTime] = useState("");
  useEffect(() => {
    const tick = () => setTime(new Intl.DateTimeFormat("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: "Asia/Kolkata" }).format(new Date()));
    tick(); const t = setInterval(tick, 30000); return () => clearInterval(t);
  }, []);
  return (
    <footer className="theme-ink page-x pt-20 pb-12" data-testid="site-footer">
      <div className="wrap">
        <p className="mono mb-5" style={{ color: "var(--lime)" }}>/ GOT A BRIEF?</p>
        <h2 className="display" style={{ fontSize: "clamp(44px,9vw,150px)", color: "#fff" }}>
          LET'S <span className="serif" style={{ color: "var(--lime)" }}>open</span> A FILE.
        </h2>
        <a href={`mailto:${EMAIL}`} className="ul inline-block mt-8" style={{ fontSize: "clamp(20px,3vw,40px)", color: "#fff", borderBottom: "2px solid var(--lime)" }} data-testid="footer-email">
          {EMAIL}
        </a>
        <div className="flex flex-wrap gap-x-8 gap-y-3 mt-12 mono" style={{ color: "rgba(255,255,255,.7)" }}>
          <a href={LINKEDIN} target="_blank" rel="noreferrer" className="ul" style={{ color: "#fff" }}>LinkedIn ↗</a>
          <a href="https://www.behance.net/poonambaid" target="_blank" rel="noreferrer" className="ul" style={{ color: "#fff" }}>Behance ↗</a>
          <a href="https://www.instagram.com/vdesigns.eps" target="_blank" rel="noreferrer" className="ul" style={{ color: "#fff" }}>Instagram ↗</a>
          <span>Gurugram · {time} IST</span>
          <span><span style={{ color: "var(--lime)" }}>●</span> {AVAIL}</span>
          <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="ul" style={{ color: "#fff", marginLeft: "auto" }}>Back to top ↑</button>
        </div>
      </div>
    </footer>
  );
}
